import dayjs from "dayjs";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { MediaCatalogueItem } from "../../../models/MediaCatalogueItem";
import ModalConfirm from "../../ModalConfirm";

import "./styles.scss";

interface IMediaCatalogueItemCardProps {
  item: MediaCatalogueItem;
  onDelete?: (item: MediaCatalogueItem) => void;
}

export const MediaCatalogueItemCard: React.FunctionComponent<
  IMediaCatalogueItemCardProps
> = ({ item, onDelete }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) => _t(`mediaCatalogueItemCard.${key}`);

  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const handleConfirmDelete = (event: React.MouseEvent) => {
    event.preventDefault();
    if (onDelete) onDelete(item);
    setShowDeleteModal(false);
  };

  return (
    <>
      <div className="media-catalogue-item-card">
        <div className="card-top-info">
          <div className="card-date">
            {dayjs(item.created_at).format("YYYY-MM-DD")}
          </div>
        </div>
        <a
          className="card-image-container"
          href={item.signed_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            className="card-image"
            src={item.signed_url}
            alt={item.description || t("image_alt")}
            referrerPolicy="no-referrer"
          />
          {item.description && (
            <div className="card-description">{item.description}</div>
          )}
        </a>
        {onDelete && (
          <div className="card-controls">
            <button
              className="btn btn-red"
              onClick={() => setShowDeleteModal(true)}
              type="button"
            >
              {t("delete")}
            </button>
          </div>
        )}
      </div>
      {showDeleteModal && (
        <ModalConfirm
          title={t("deleteModal.title")}
          cancelLabel={t("deleteModal.cancel")}
          confirmLabel={t("deleteModal.confirm")}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmDelete}
          translate={false}
          color="red"
        />
      )}
    </>
  );
};

export default MediaCatalogueItemCard;
